import { formatLocale, roundNumber } from '@util/numberFormat' // eslint-disable-next-line no-unused-vars

export function formatTripOdometer (value: number) {
  if (value || value === 0) {
    return formatLocale(roundNumber(value / 1000, 2), 2)
  }
  return ''
}
export function formatOdometer (odometer: number) {
  if (odometer || odometer === 0) {
    return odometer.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
  return ''
}

export const MIN_ODOMETER_GAP = 500

export default {
  formatOdometer,
  formatTripOdometer
}
